import { Link } from 'react-router-dom'
import { P, Callout } from '../components'

// ─── Status: not yet written ─────────────────────────────────────────────────
// Held as draft until we have a curated list of real error strings to
// document. Writing this article blind would mean inventing error messages
// that don't actually appear in the product, which is worse than nothing.
// If a customer reports an error they don't understand, that message goes
// on the list and we add it here.

export default {
  title:   'Common error messages and what they mean',
  summary: 'Plain-English explanations for the error messages you might see, and how to fix each one.',
  draft:   true,
  body: (
    <>
      <P>
        We're still working on this article. Rather than write generic
        guidance that doesn't match what you actually see in the app,
        we're collecting real error messages and writing a specific
        explanation for each one.
      </P>

      <Callout variant="info" title="Hit an error you don't understand?">
        Send us a screenshot or the exact wording via the{' '}
        <Link to="/support/contact">support form</Link>. We'll get
        you unstuck and add the message to this guide so the next
        person who sees it has an answer.
      </Callout>
    </>
  ),
}
